import { render, staticRenderFns } from "./IconWarning.vue?vue&type=template&id=0a2b32c7&scoped=true"
import script from "./IconWarning.vue?vue&type=script&lang=js"
export * from "./IconWarning.vue?vue&type=script&lang=js"
import style0 from "./IconWarning.vue?vue&type=style&index=0&id=0a2b32c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b32c7",
  null
  
)

export default component.exports